import { Town } from 'src/api/types';

import { TownsState } from './types';

export const emptyTowns = new Map<number, Town>();

export const initialState: TownsState = {
  loading: false,
  currentRequestId: undefined,
  towns: emptyTowns,
};
